import { Skeleton } from '@synoptic/ui-kit/skeleton/skeleton.tsx';
import {
  nudgeLeftContainer,
  nudgeCard,
  nudgeDescription,
  nudgeTitle,
} from './nudge-card.css.ts';

export const NudgeFallback = () => {
  return (
    <div className={nudgeCard}>
      <div className={nudgeLeftContainer}>
        <div>
          <h4 className={nudgeTitle}>
            <Skeleton height={20.8} width={350} />
          </h4>
          <div className={nudgeDescription}>
            <Skeleton height={18.2} width={170} />
          </div>
        </div>
        <Skeleton height={32} width={150} />
      </div>
    </div>
  );
};
